import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Lab } from '../../../../src/modals/lab.model';

@Component({
  selector: 'cloudlabs-lab-environment-list-view',
  templateUrl: './lab-environment-list-view.html',
  styleUrls: ['./lab-environment-list-view.scss'],
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class LabEnvironmentListView {
  @Input() cloudprovider: any;
  @Input() pasteInVM: boolean;
  @Input() outputParameter = false;
  @Input() accordionToggleInfo = { 1: true };
  @Input() selectedTab = 'Azure';
  @Input() labDetail: Lab;
  @Input() gcpLink;
  @Input() attendeLabDetails: any;
  @Input() minGuide: boolean;
  @Input() type: string;
  @Input() awsLink;
  @Input() mode: string;
  @Input() operationModes;
  @Input() subscriptionError;
  @Input() ociLink;
  @Output() toggle = new EventEmitter<number>();
  @Output() launchVM = new EventEmitter<any>();
  @Output() submitAzurePass = new EventEmitter<any>();
  @Output() launchLab = new EventEmitter<void>();
  @Output() openVm = new EventEmitter<any>();

  constructor(){
    //
  }

  onToggle(index: number) {
    this.accordionToggleInfo[index] = !this.accordionToggleInfo[index];
  }
  
  trackByFn(index: number, item: any) {
    return item.ResourceGroupName;
  }

  onLaunchClick(vm: any) {
    this.launchVM.emit(vm);
  }

  onSubmitForm(formValue: any) {
    this.submitAzurePass.emit(formValue);
  }

  onStartLab() {
    this.launchLab.emit();
  }

  onOpenVm(vm: any) {
    this.openVm.emit(vm);
  }
}
